import $ from 'jquery';

export function generateCss ($headings) {
    const properties = [['border', 'border-color'], ['text', 'color'], ['background', 'background-color']];
    const prefixes = ['primary', 'secondary', 'spot', 'zebra', 'spot-front'];
    const css = [];
    $headings.each(function () {
        const $heading = $(this);
        const data = $heading.data('color-schema');
        const colors = data.replace('--color-schema-', '').split('-');
        for (let i = 0; i < colors.length; ++i) {
            const color = colors[i];
            const prefix = prefixes[i];
            for (const [name, prop] of properties) {
                const styles = `
                    .${data} .${prefix}-${name} {
                        ${prop}: #${color} !important;
                        transition: all 800ms;
                        --${name}-color: #${color};
                    }
                    .${data}.${prefix}-${name} {
                        ${prop}: #${color} !important;
                        transition: all 800ms;
                        --${name}-color: #${color};
                    }
                `;
                css.push(styles);
            }

            css.push(`
                .${data} .${prefix}-outline {
                    --outline-color: #${color};
                }
                body.${data}:not(.using-mouse) .${prefix}-outline:focus {
                    outline: 0.2rem solid #${color} !important;
                }
            `);
        }
    });

    $(document.head).append(`
        <style type="text/css">
            ${css.join('\n')}
        </style>
    `);
}
